import { render, staticRenderFns } from "./PersonalizationImages.vue?vue&type=template&id=15c999da&scoped=true&"
import script from "./PersonalizationImages.vue?vue&type=script&lang=js&"
export * from "./PersonalizationImages.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizationImages.vue?vue&type=style&index=0&id=15c999da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c999da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VIcon,VList,VListItem,VListItemTitle,VMenu,VSkeletonLoader})
